import {matchPath, useLocation} from "react-router";

import {ILayoutOptions, IVisualRoute} from "../types/IVisualRoute";

export function useLayoutOptions(routes: IVisualRoute[]): ILayoutOptions {
    const location = useLocation();

    const matchedRoute = routes.find((route) => {
        const routePaths = Array.isArray(route.path) ? route.path : [route.path];
        return routePaths.some((p) => p && matchPath(location.pathname, {path: p, exact: route.exact !== false}));
    });

    return matchedRoute?.layoutOptions ?? {};
}
